import { GameUI } from "game/gameUI/GameUI"
import { translate } from "game/translate"
import { Popups } from "ui/types/popups"

export const MagicWandPopup = () => {
    return (
        <div id="magic-wand" role="tooltip" className="magic_wand modals_area active">
            <div className="wrapper">
                <button type="button" className="close_btn close" onClick={() => GameUI.closePopup(Popups.MAGIC_WAND_POPUP)}></button>
                <div className="text_content">
                    <span className="modals_area-title">{translate("magic_wand_title")}</span>
                    <img loading="lazy" className="modals_area_img" src="/assets/magic_wand_modals/magic_wand_img.webp"  />
                    <p className="modals_area-text">{translate("magic_wand_text")}</p>
                    <button onClick={() => GameUI.closePopup(Popups.MAGIC_WAND_POPUP, true)} type="button" className="modals_area-btn">{translate("magic_wand_btn")}</button>
                </div>
            </div>
        </div>
    )
}